module.exports = __webpack_public_path__ + "img/features1.9acecacc.png";